import axiosClient from '../api/AxiosConfig';

export const BannerService = {
  GetBanner: async () => {
    return (await axiosClient.get('/banner')).data;
  },
  DisableBanner: async (id) => {
    return (await axiosClient.put(`/banner/${id}/inactive`)).data;
  },
  EnableBanner: async (id) => {
    return (await axiosClient.put(`/banner/${id}/active`)).data;
  },
  CreateBanner: async (data) => {
    return (await axiosClient.post(`/banner`, data)).data;
  },
  DeleteBanner: async (id) => {
    return (await axiosClient.delete(`/banner/${id}/delete`)).data;
  },
  EditStt: async (data) => {
    return (await axiosClient.put('/banner', { data })).data;
  },
};
